import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/api";
import { toast } from "react-toastify";


export const getRecievedEnquirydetailsThunk = createAsyncThunk(
    'bom/getRecievedEnquirydetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getRecievedEnquiries(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportRecievedEnquirydetailsThunk = createAsyncThunk(
    'bom/exportRecievedEnquirydetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getRecievedEnquiries(data);
            
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getRecievedDetailsThunk = createAsyncThunk(
    'bom/getRecievedDetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getRecievedDetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const recievedEnquiriesSlice = createSlice({
    name: 'recievedEnquiries',
    initialState: {
        enquiries: [],
        enquiryDetails: {},
        loading: false,
        refresh: false,
        alterLoading: false,
        bomEnquiries: [],
        page: 1,
        status:''

    },
    reducers: {
        setRecievePage: (state, action) => {
            state.page = action.payload
        },
        setReceiveEnquiryRefresh:(state,action)=>{
            state.refresh = !state.refresh
        },
        setRecievestatus:(state,action)=>{
            state.status = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRecievedEnquirydetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getRecievedEnquirydetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.enquiries = action.payload
            })
            .addCase(getRecievedEnquirydetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getRecievedDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getRecievedDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.enquiryDetails = action.payload
            })
            .addCase(getRecievedDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })
    },
})

export const { setRecievePage,setReceiveEnquiryRefresh,setRecievestatus } = recievedEnquiriesSlice.actions;
export default recievedEnquiriesSlice.reducer
